export { default as Event } from './Event'; // 事件件对象
export { default as Message } from './Message'; // 消息对象



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-react-box/node_modules/grey-message/index.js
// module id = 4334
// module chunks = 0